import { render, staticRenderFns } from "./LayoutBlank.vue?vue&type=template&id=028ac536&scoped=true"
import script from "./LayoutBlank.vue?vue&type=script&lang=js"
export * from "./LayoutBlank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ac536",
  null
  
)

export default component.exports